<template>
    <div>
        <h2>OS Itens (RE)</h2>
        <div class="d-flex w-100 gap-10 search-form">
            <form class="w-100 flex-grow-1 d-flex justify-center align-baseline" @submit.prevent="getItensOs">
                <v-row no-gutters style="gap: 15px;">
                    <v-text-field
                        cols="6"
                        class="pt-5 pb-5"
                        chips
                        v-model="filter.search"
                        clearable
                        hide-details
                        hide-selected
                        prepend-icon="mdi-magnify"
                        label="Item"
                        solo
                    />
                
                    <v-text-field 
                        v-model="filter.os"
                        cols="6"
                        class="pt-5 pb-5"
                        type="text" 
                        label="OS"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        solo
                    ></v-text-field>
                            
                    <v-text-field 
                        v-model="filter.job"
                        cols="6"
                        class="pt-5 pb-5"
                        type="text" 
                        label="JOB"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        solo
                    ></v-text-field>
                    
                    <v-btn type="submit" color="primary" large class="mt-5">Buscar</v-btn>
                </v-row>

            </form>

            <div class="text-center">
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="primary"
                            v-on="on" 
                            large
                            :disabled="selected.length == 0"
                        >
                            Ações em Massa...
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            v-for="(item, index) in actionsMassa"
                            :key="index"
                            :value="index"
                            @click="item.handle"
                            class="cursor-pointer"
                        >
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>

                </v-menu>
            </div>
        </div>
        
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            class="elevation-1 mt-10"
            disable-sort
            hide-default-footer
            :page.sync="page"
            item-value="name"
            show-select            
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            return-object
        >

        <template v-slot:[`header.data-table-select`]="{  }">
        <!-- <v-checkbox
            v-model="props.every"
            :indeterminate="props.some && !props.every"
            :disabled="true"
            @click.stop
        /> -->
        </template>
        
        <template v-slot:header:[`data-table-select`]>
            <v-checkbox disabled />
        </template>
        
            <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" style="display: flex; justify-content: center;">
                        <v-checkbox
                        :input-value="isSelected"
                        @click.stop="select(!isSelected)"
                        :disabled="selected.some(s => s.ordemDeServico?.codigo !== item.ordemDeServico?.codigo) || item.destino == 'ND'"
                        />
                    </div>
                    </template>
                    <span class="bg-deep-purple text-white px-2 py-1 rounded">
                        {{
                            selected.some(s => s.ordemDeServico?.codigo !== item.ordemDeServico?.codigo)
                            ? 'Não pode selecionar os diferentes' 
                            : item.destino == 'ND' ? 'Não pode selecionar item sem destino' 
                            : 'Clique para selecionar este item'
                        }}
                    </span>
                </v-tooltip>
            </template>
            
            <template v-slot:[`item.ordemDeServico`]="{ item }">
                <span>
                    {{ item.ordemDeServico?.codigo || "Não Informado" }}
                </span>
            </template>

            <template v-slot:[`item.jobCodigo`]="{ item }">
                <span>
                    {{ item.ordemDeServico?.jobCodigo || "Não Informado" }}
                </span>
            </template>

        </v-data-table>
        
        <div class="text-center pt-2">
            <v-pagination
                v-model="page"
                :length="pageCount"
                @input="pagination"
            ></v-pagination>
        </div>

        <CreateListEmbView 
            :open="openModalCreateListEmb"
            :selectedItems="selected"
            @save="saveListEmb"
            @close="openModalCreateListEmb = false"
        />

    </div>
</template>

<script>
import Vue from 'vue';
import EntityService from "@/services/entityService.js";
import CreateListEmbView from './CreateListEmbView'

export default {
    name: 'ItensRE',
    components: {
        CreateListEmbView
    },
    data() {
        return {
            filter: {
                search: '',
                job: '',
                os: ''
            },
            selected: [],
            entityService: new EntityService('OrdemDeServicoItens'),
            items: [],
            page: 1,
            pageCount: 0,
            itemsPerPage: 0,
            openModalCreateListEmb: false,
            headers: [
                { text: "Seq", value: "sequencia" },
                { text: "Descrição", value: "descricao" },
                { text: "OS", value: "ordemDeServico" },
                { text: "JOB", value: "jobCodigo" },
                { text: "Destino", value: "destino"},
                { text: "Unidade", value: "unidadeSigla" },
                { text: "QTD", value: "quantidade" },
                { text: "Status", value: "status" }
            ],
            idsItemCaldeiraria: [ "9100000", "9500000" ],
            actionsMassa: [
                { 
                    title: 'Gerar Lista de Embarque',
                    handle: () => {
                        this.openModalCreateListEmb = true
                    }
                },
                {
                    title: 'Devolver Para Almoxarifado',
                    handle: () => this.changeStatus('LA')
                },
                {
                    title: 'Dar Baixa Para ET',
                    handle: () => this.changeStatus('ET')
                }
            ],
            
            actions: [
                {
                    icon: "mdi-pencil",
                    color: "warning",
                    title: "Visualizar/Editar",
                    handle: () => {
                        //this.editItem();
                    },
                },
                {
                    icon: "mdi-delete",
                    color: "error",
                    title: "Deletar",
                    handle: (typeDelte) => {
                        if (typeDelte == 'deleteMany') {
                            //this.itemsForDelete();
                        } else {
                            //this.deleteItem();
                        }
                    },
                },
            ],
        }
    },

    methods: {
        async getItensOs(){
            //const response = await this.entityService.getAll(1, 30, `RE,${this.search}`, 'status,descricao', null, null, null)

            let response = await Vue.prototype.$http.post('/View/run', {
                "params": [
                    { dataType: "string", name: "descricao", value: this.filter.search },
                    { dataType: "string", name: "osCodigo", value: this.filter.os },
                    { dataType: "string", name: "jobCodigo", value: this.filter.job }
                ],
                "viewId": "420cb045-f57b-4079-8e0e-e687f42adf2c",
                "page": this.page,
                "limit": 30
            });

            this.items = response.data.data.data
            this.pageCount = response.data.data.pages
            this.itemsPerPage = response.data.data.limit

        },

        async saveListEmb(e, listEmb, subItem, subItemForSend){
            this.selected = e
            this.openModalCreateListEmb = false

            console.log('TESTE >>> ', e, listEmb, subItem)

            await this.generatedListEmb(listEmb, subItem, subItemForSend)
        },

        async generatedListEmb(listEmb, subItem, subItemForSend){
            console.log('aqui ', this.selected)

            let itensListEmbResponse = []
            let subItemsSend = []

            await Promise.all(this.selected.map(async (item, indexListEmb) => {
                console.log('TESTE >>> ', item)

                let osItens = []

                let lastIndex = 1
                if(this.idsItemCaldeiraria.includes(item.itemCodigo)){
                    const findItem = subItem.find(si => si.idSelected === item.id)

                    subItemsSend = findItem.items.filter((itemPav) => subItemForSend.includes(itemPav.id))
                    osItens = subItemsSend

                    const listEmbItem = osItens?.map((ordemItem, index) => {
                        lastIndex = index
                        return {
                            sequencia: index + 1,
                            itemCaldeiraria: ordemItem.id,
                            descricao: ordemItem.description,
                            quantidade: ordemItem.qtdEntregue,
                            pesoTotal: ordemItem.totalWeight
                        }
                    })

                    console.log('subItemsSend >>> ', listEmbItem)

                    if(listEmbItem.length > 0){
                        const responseListEmbItem = await Vue.prototype.$http.post('/Entity/insertMany/PackingListEmbItem', listEmbItem);
                        responseListEmbItem.data.data.map((item) => {
                            itensListEmbResponse.push(item)
                        })
                        
                    }

                }

                if(item?.ordemDeServico?.itens.length > 0 && (!this.idsItemCaldeiraria.includes(item.itemCodigo) || item.completedItem)){
                    const response = await this.entityService.getAll(1, 30, null, null, item?.id, null, null)
                    osItens = response.data.data.data   
                

                    const listEmbItem = osItens.map((ordemItem, index) => {
                        return {
                            sequencia: index + lastIndex,
                            ordemDeServicoItem: ordemItem.id,
                            descricao: ordemItem.descricao,
                            unidade: ordemItem.unidade,
                            quantidade: ordemItem.quantidadeEntregue,
                            pesoTotal: ordemItem.pesoTotal
                        }
                    })

                    if(listEmbItem.length > 0){
                        const responseListEmbItem = await Vue.prototype.$http.post('/Entity/insertMany/PackingListEmbItem', listEmbItem);
                        itensListEmbResponse.push(responseListEmbItem.data.data[0])
                    }
                }
                
            }))

            const response = await Vue.prototype.$http.get('/Entity/PackingListEmb/search-fields', {
                params: {
                    value: `LEM-${this.selected[0].ordemDeServico?.jobCodigo || ''}-${this.selected[0].ordemDeServico?.codigo || ''}`,
                    mode: 'Contains',
                    searchFields: 'codigo',
                    limit: 9999
                }
            });

            const code =  `LEM-${this.selected[0].ordemDeServico?.jobCodigo || ''}-${this.selected[0].ordemDeServico?.codigo || ''}-${response.data.data.data.length + 1 || 1}`

            console.log('itensListEmbResponse >>> ', itensListEmbResponse)

            const newsListEmb = {
                codigo: code,
                status: "Elaboração",
                destino: "Cliente",
                job: this.selected[0].ordemDeServico?.job,
                ordemDeServico: this.selected[0].ordemDeServico?._id,
                cliente: listEmb.cliente,
                clienteEntrega: '',
                fornecedor: this.selected[0]?.fornecedor || '',
                descricao: `Criado a partir da OS ${this.selected[0].ordemDeServico?.codigo}`,
                fornecedorEntrega: this.selected[0].fornecedorMaterialFornecido || '',
                dataCriacao: new Date().toISOString(),
                itens: itensListEmbResponse?.map((item) => item.id),
                contratoInterno: `Job:${this.selected[0].ordemDeServico?.jobCodigo || ''} - OS:${this.selected[0].ordemDeServico?.codigo || ''}`,
                contratoExterno: `Job:${this.selected[0].ordemDeServico?.jobCodigo || ''} - OS:${this.selected[0].ordemDeServico?.codigo || ''}`,
                numeroVolumes: itensListEmbResponse.length || 0,
                pesoLiquido: Number(listEmb.pesoLiquido) || 0,
                pesoBruto: Number(listEmb.pesoBruto) || 0,
                responsavel: Number(listEmb.responsavel) || '',
                observacao: Number(listEmb.observacao) || ''
            }

            const responseListEmb = await Vue.prototype.$http.post('/Entity/PackingListEmb', newsListEmb);
            //console.log('responseListEmb >>> ', responseListEmb)
            
            if(responseListEmb.data.success){
                await Promise.all([
                    this.updateOrdemServicoItem(),
                    this.updateQtdPav(subItemsSend)
                    //this.generatedRomaneio(responseListEmb.data.data)
                ])
                
                this.$notfy.success(`Success.`);
                this.selected = []
                this.getItensOs()
            } else {
                this.$notfy.error("Erro.");
            }

        },

        async generatedRomaneio(listEmb){

            console.log('listEmb >> ', listEmb.job, this.selected[0])

            const itemRomaneio = await Vue.prototype.$http.post('/Entity/RomaneioPackingList', {
                listaDeEmbarque: listEmb.id
            })

            await Vue.prototype.$http.post('/Entity/Romaneio', {
                dataCriacao: new Date().toLocaleDateString(),
                job: [ listEmb.job ],
                vlrTotal: this.selected[0].valorTotal,
                itens: [ itemRomaneio.data.data.id ]
            });
        },

        async updateOrdemServicoItem(){

            let itensSend = this.selected.filter((itemSelected) => !this.idsItemCaldeiraria.includes(itemSelected.itemCodigo) || itemSelected.completedItem)

            itensSend?.map((item) => {
                
                delete item?.createAt
                delete item?.updatedAt
                delete item?.updateBy
                delete item?.createBy
                delete item?.updateBy
                delete item?.deleteAt
                delete item?.deleteBy
                delete item?.ordemDeServico
                delete item?.subItem
                delete item?.ordemDeServico
                delete item?.completedItem

                item.quantidade = item.quantidade - item.quantidadeEntregue

                return item
                
            })

           if(itensSend.length > 0) await Vue.prototype.$http.put('/Entity/updateMany/OrdemDeServicoItens', itensSend);

        },

        async updateQtdPav(itemsUpdate){
            console.log('itemsUpdate >>> ', itemsUpdate)
            itemsUpdate?.map((item) => {
                
                delete item?.createAt
                delete item?.updatedAt
                delete item?.updateBy
                delete item?.createBy
                delete item?.updateBy
                delete item?.deleteAt
                delete item?.deleteBy
                delete item?.ordemDeServico
                delete item?.subItem
                delete item?.ordemDeServico
                delete item?.completedItem
                delete item.os


                item.qtd = item.qtd - item.qtdEntregue

                if(item.qtd <= 0){
                    item.status = 'ET'
                }

                delete item.qtdEntregue

                return item
                
            })

            if(itemsUpdate.length > 0) await Vue.prototype.$http.put('/Entity/updateMany/PAV', itemsUpdate);
        },

        async changeStatus(status){

            await this.saveHistoricChange(status)

            const itemsUpdate = this.selected.map((item) => {
                delete item?.createAt
                delete item?.updatedAt
                delete item?.updateBy
                delete item?.createBy
                delete item?.updateBy
                delete item?.deleteAt
                delete item?.deleteBy
                delete item?.ordemDeServico

                item.status = status

                return item
            })

            await Vue.prototype.$http.put('/Entity/updateMany/OrdemDeServicoItens', itemsUpdate)
            this.getItensOs()
        },

        async saveHistoricChange(status){
            let itemsPost = []

            const user = await this.$auth.getUserParams();

            console.log('USER >>> ', user)

            this.selected.map((item) => {
                itemsPost.push({
                    novo_status: status,
                    itemId: item.item,
                    os: item?.ordemDeServico?.codigo,
                    osItem: item.id,
                    date_change: new Date().toDateString(),
                    time: new Date().toLocaleTimeString(),
                    user: user.user
                })
            })

            console.log('itemsPost >>> ', itemsPost)

            await Vue.prototype.$http.post('/Entity/insertMany/HistoricoMudancaStatus', itemsPost)

        },

        pagination(page) {
            this.page = page
            this.getItensOs()
        },
    },

    watch: {
        selected(news){
            console.log('news >>> ', news)
            // this.saveHistoricChange("LA")
        }
    },

    async created(){
        await this.getItensOs()
    }
}
</script>


<style scoped>
    .container {
        width: '100%'
    }

    .search-form {
        gap: 10px;
        align-items: center;
    }
</style>